import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

export const Layout: FC<LayoutProps> = ({ header, footer, children }): ReactNode => {
    return (
        <div className='relative flex min-h-screen flex-col overflow-x-clip'>
            <a
                href='#main'
                className='sr-only z-[70] rounded-full bg-ink px-5 py-3 text-sm text-mist focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                メインコンテンツへスキップ
            </a>

            {header}

            <main id='main' className='flex-1'>
                {children}
            </main>

            {footer}

            <div aria-hidden='true' className='film-grain pointer-events-none fixed inset-0 z-30 hidden opacity-[0.07] lg:block' />
        </div>
    )
}
